import { Component, DoCheck, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Globals } from 'app/globals';
import { ToastrService } from 'ngx-toastr';
declare var jquery: any;
declare var $: any;
import { AdminService } from 'app/services/admin/AdminService';
import { ClientsService } from 'app/services/client/ClientsService';
import { CryptoJs } from '../shared/crypto-js/crypto-js.component';
import { UserLoggedInService } from '../services/angular/UserLoggedIn';
import { Idle } from '@ng-idle/core';
import { isNull } from 'util';
import { ELIAPIService } from '../services/eliapi/ELIAPIService';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy, DoCheck {

    currentYear = new Date().getFullYear();
    user = {
        email: null,
        pass: null
    }

    attempts = 0;
    loading = false;
    authenticateUserData: any;
    isOldUser: boolean = false;

    constructor(
        private _AdminService: AdminService,
        private _ClientsService: ClientsService,
        private router: Router,
        public _Globals: Globals,
        private toastr: ToastrService,
        private _CryptoJs: CryptoJs,
        private _UserLoggedInService: UserLoggedInService,
        private idle: Idle,
        private _ELIAPIService: ELIAPIService,

    ) {
        const mode = this._Globals.getMode();
        if (mode === null) {
            localStorage.removeItem('kUvPfGbd6J');
            console.log('mode', mode);
        }
        if (!this._Globals.raterAssignedAssessment) {
            this._Globals.loginModeredirection(mode);
        } else {
            $('body').css('cursor', 'default');
        }

        this._Globals.invitacionLinkCompareIds = false;
    }

    ngOnInit() {
        if (this._Globals.raterAssignedAssessment) {
            this.user.email = this._Globals.raterEmail;
            this.user.pass = '';
        }

        // setting the field email when the client or rater is trying to loggin
        // setting the field email when the coach is seeing results and trying to loggin
        if (this._Globals.isClientTakeAssessment || this._Globals.isCoachSeeingResults) {
            this.user.email = this._Globals.invitationLinkUserEmail;
        } else {
            this.user.email = this._Globals.userEmail;
        }
    }

    ngOnDestroy() {
        this.attempts = 0;
        // this.myGlobals.invitationLinkAssignmentId = undefined;
        this._Globals.aResultCoachId = undefined;
        this._Globals.isClientTakeAssessment = false;
        this._Globals.isCoachSeeingResults = false;
    }

    ngDoCheck() {
        console.log('ngOnChanges');
        $('#hubspot-messages-iframe-container').css({
            'opacity': '0',
            'pointer-events': 'none'
        });
    }

  preventSpace(value: string, event: any) {
      const tagName = event.target.id;

      if (value == null || value === '') {
          if (Number(event.keyCode)  === 32) {
              return false;
          }
      }
      if (value === ' ') {
          $('#' + tagName).val('');
      }
  }

  authenticateUser(form: NgForm) {
      $('body').css('cursor', 'wait');
      $('.btn').prop('disabled', true);

      console.log('form', form);
      const email = form.value.email;
      const pass = form.value.pass;

      if (!email || !pass) {
          if (!email) {
              $('#email').focus();
          } else {
              $('#pass').focus();
          }
          this.toastr.warning('Invalid login credentials', 'ELI');
          $('body').css('cursor', 'default');
          $('.btn').prop('disabled', false);
          return;
      }


      this._AdminService.postAuthenticateUser(email, this._CryptoJs.encrypt(pass, this._Globals.lpassString))
          .subscribe(
              data => {
                  console.log('data', data.result);

                  switch (data.result.Result) {
                    case -45:
                        this.toastr.error('No access to the beta environment.', 'ELI');
                        $('body').css('cursor', 'default');
                        $('.btn').prop('disabled', false);
                        break;
                    case -44:
                    case -43:
                    case -41:
                    case -40:
                        this.toastr.error('Inconsistent credentials. Please contact support.', 'ELI');
                        $('body').css('cursor', 'default');
                        $('.btn').prop('disabled', false);
                        break;
                    case -42:
                        this.toastr.error('User not found.', 'ELI');
                        $('body').css('cursor', 'default');
                        $('.btn').prop('disabled', false);
                        break;
                    case -30:
                            this.toastr.error('Account suspended. Please contact support.', 'ELI');
                            $('body').css('cursor', 'default');
                            $('.btn').prop('disabled', false);
                            break;
                    case -20:
                          this.toastr.error('Invalid login credentials.', 'ELI');
                          $('body').css('cursor', 'default');
                          $('.btn').prop('disabled', false);
                          break;

                    case 1:
                          this._UserLoggedInService.setUserLoggedIn(true);
                          this.idle.watch();
                          this._Globals.setAnnouncementsStatus(true);

                          // validation for the assessment report link from assessment-report.component (coach mode)
                          if (this._Globals.isClientTakeAssessment || this._Globals.isCoachSeeingResults) {
                              this.attempts++;
                          }

                          if (this.attempts > 3) {
                              if (this._Globals.isClientTakeAssessment) { this._Globals.isClientTakeAssessment = false; }
                              if (this._Globals.isCoachSeeingResults) { this._Globals.isCoachSeeingResults = false; }

                              this.toastr.warning('You have already exceeded your maximum attempts to take this assessment. Please click again the email link.', 'ELI');
                          }

                          this._Globals.setToken(data.result.AccessToken);
                          this._Globals.setFullName(data.result.DskjoXCn0f, data.result.QyKZJFsEvu);
                          this._Globals.setUserId(data.result.OepbCPnScZ);
                          let mode: string;
                          if (String(this._CryptoJs.decrypt(data.result.kUvPfGbd6J, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*')) === 'Manager') {
                              mode = this._CryptoJs.encrypt('Administrator', '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*');
                              this._Globals.setUserType('manager');
                          } else {
                              mode = data.result.kUvPfGbd6J;
                              this._Globals.setUserType('Administrator');
                          }
                          this._Globals.setMode(mode);
                          this._Globals.setAvailableModes(data.result.v31Ng7c6zu);

                          this._Globals.setUserEmail(this._CryptoJs.encrypt(this.user.email, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                          this._Globals.setCanUserEditEmail(Number(data.result.YE3) === 1 ? true : false);
                          this._Globals.setIsUserStudent(data.result.NR9);
                          this._Globals.setBetaAccess(data.result.z6NjHUJe4f);
                          this._Globals.setEnvironment(data.result.fDISWvalw6);

                          if (this._Globals.invitationLinkFrom === '') {
                              if (Number(data.result.Status) === 1 && (String(this._CryptoJs.decrypt(data.result.kUvPfGbd6J, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*')) === 'Client' || String(this._CryptoJs.decrypt(data.result.kUvPfGbd6J, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*')) === 'Rater')) {
                                  const lastAssignment = data.result.LastAssignment;
                                  const last360Assignment = data.result.Last360Assignment;

                                  if (!this._Globals.assessmentCompleted) {
                                      if (!isNull(lastAssignment)) {
                                          if (Number(lastAssignment.AssignmentId) !== 0) {
                                              // redirect to the assessment
                                              // assigned_assessment/pending/1/558/ELI%20-%20Self%20Assessment/en
                                              this.router.navigate(['/app/assigned_assessment', 'pending',
                                                  lastAssignment.AssessmentId,
                                                  lastAssignment.AssignmentId,
                                                  lastAssignment.AssessmentName,
                                                  lastAssignment.Language],
                                                  {state: { showBanner: false }});
                                              $('body').css('cursor', 'default');
                                              return;

                                          }
                                      } else if (!isNull(last360Assignment)) {
                                          if (Number(last360Assignment.AssignmentId) !== 0) {
                                              // redirect to the 360 assessment
                                              // assigned_assessment/rater/34/312/ELI%20360/en/Testicular%20Testasaurus
                                              this.router.navigate(['/app/assigned_assessment', 'rater',
                                                  last360Assignment.AssessmentId,
                                                  last360Assignment.AssignmentId,
                                                  last360Assignment.AssessmentName,
                                                  last360Assignment.Language,
                                                  last360Assignment.ClientFirstName + '' + last360Assignment.ClientLastName],
                                                  {state: { showBanner: false }});
                                              $('body').css('cursor', 'default');
                                              return;

                                          }
                                      }

                                  } else {
                                      this._Globals.assessmentCompleted = false;
                                      console.log('NO ASSESSMENTS PEDINGS - OR - NORMAL REDIRECT');
                                  }
                              }
                          }

                          // Redirect user to the activate account screen when Status equals to 2 and user_type is 3 or 4
                          let _data = Number(this._CryptoJs.decrypt(data.result.Ku1TT0DbLn, this._Globals.passString));
                          if (Number(data.result.Status) === 2 &&
                              (Number(_data) === 3 || Number(_data) === 4)) {
                              this._Globals.clientOrRaterEmailFromLogin = this.user.email;
                              this._Globals.clientOrRaterNameFromLogin = data.result.FirstName;
                              this._Globals.clientOrRaterLastFromLogin = data.result.LastName;
                              this.redirectToActivateAccount();
                              return;
                          }

                          if (this._Globals.raterAssessmentId) {
                              if (Number(data.result.Status) === 1) {
                                  // take assessment
                                  this.router.navigate(
                                    ['/app/assigned_assessment',
                                     'rater',
                                     this._Globals.raterAssignedAssessment,
                                     this._Globals.raterAssessmentName]);
                                  $('body').css('cursor', 'default');
                                  return;
                              }

                              if (Number(data.result.Status) === 2) {
                                  this.redirectToActivateAccount();
                                  return;
                              }

                              return;
                          }

                          if (this._Globals.isClientTakeAssessment) {
                              this.getAssignmentDetails(data.result.Status);
                              return;
                          }

                          if (this._Globals.isCoachSeeingResults) {
                              this.logginToAssessmentResults();
                              return;
                          }

                          if (!this._Globals.isCoachSeeingResults || !this._Globals.isClientTakeAssessment) {
                              this._Globals.loginModeredirection(this._CryptoJs.decrypt(data.result.kUvPfGbd6J, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                          }
                          break;

                      default:
                          // -1 invalid user
                          // 0 invalid password
                          this.toastr.error('Invalid login credentials', 'ELI');
                          $('body').css('cursor', 'default');
                          $('.btn').prop('disabled', false);
                          return;
                  }
              },
              error => {
                  console.error(error);
                  this.toastr.error('An error happen please try again.', 'ELI');
                  $('body').css('cursor', 'default');
                  $('.btn').prop('disabled', false);
              },
          () => {
              // console.log("No errors");
                  // No errors, route to new page
              }
        );
    }

    redirectToActivateAccount(): void {

        const lastAssignment = this.authenticateUserData.LastAssignment;
        const last360Assignment = this.authenticateUserData.Last360Assignment;

        if (!isNull(lastAssignment)) {
            if (Number(lastAssignment.AssignmentId) !== 0) {
                // redirect to the assessment
                // assigned_assessment/pending/1/558/ELI%20-%20Self%20Assessment/en
                this._Globals.activateAccountAssessmentData = '/app/assigned_assessment/pending/' +
                    lastAssignment.AssessmentId + '/' +
                    lastAssignment.AssignmentId + '/' +
                    lastAssignment.AssessmentName + '/' +
                    lastAssignment.Language;
            }
        } else if (!isNull(last360Assignment)) {
            if (Number(last360Assignment.AssignmentId) !== 0) {
                // redirect to the 360 assessment
                // assigned_assessment/rater/34/312/ELI%20360/en/Testicular%20Testasaurus
                this._Globals.activateAccountAssessmentData = '/app/assigned_assessment/rater/' +
                    last360Assignment.AssessmentId + '/' +
                    last360Assignment.AssignmentId + '/' +
                    last360Assignment.AssessmentName + '/' +
                    last360Assignment.Language + '/' +
                    last360Assignment.ClientFirstName + ' ' + last360Assignment.ClientLastName;
            }
        }

        console.log('Redirecting user to the activate account...');
        this.router.navigate(['/app/account_activation']); // , this.myGlobals.raterEmail]);
        $('body').css('cursor', 'default');
        return;
    }

    getAssignmentDetails(status: any) {
        // validate the field status
        if (Number(status) === 1) {
            if (this._Globals.getUserId() === this._Globals.invitationLinkUserId) {
                if (this._Globals.invitationLinkFrom === 'rater') {
                    this.router.navigate(
                        ['/app/assigned_assessment',
                        this._Globals.invitationLinkFrom,
                        this._Globals.invitationLinkAssessmentId,
                        this._Globals.invitationLinkAssignmentId,
                        this._Globals.invitationLinkAssessmentName,
                        this._Globals.invitationLinkLanguage,
                        this._Globals.invitationLinkFullName]);
                } else {
                    this.router.navigate(
                        ['/app/assigned_assessment',
                        this._Globals.invitationLinkFrom,
                        this._Globals.invitationLinkAssessmentId,
                        this._Globals.invitationLinkAssignmentId,
                        this._Globals.invitationLinkAssessmentName,
                        this._Globals.invitationLinkLanguage],
                        {state: { extras: { showBanner: false } }});
                }
                this._Globals.setMode(this._CryptoJs.encrypt('Client', '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                this._Globals.deactivateAllModes();
                this._Globals.client = true;
                this._Globals.selectedMode = 'client';
                this._Globals.userLoggedIn();
            } else {
                // user login valit but not mach with client id with try to take
                this.toastr.warning('Invalid user credentials for this assessment', 'ELI');
            }
            $('.btn').prop('disabled', false);
            $('body').css('cursor', 'default');
        } else {
            this.router.navigate(['/app/account_activation']);
            return;
        }
            // }
        // });
    }

    logginToAssessmentResults() {
        if (this._Globals.getUserId() === this._Globals.aResultCoachId) {
            if (this._Globals.aResultUserType === '2') {
                this.router.navigate(['/app/co_a_report', this._Globals.invitationLinkAssignmentId, 'manage_clients', 1]);
                this._Globals.setMode(this._CryptoJs.encrypt('Coach', '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                this._Globals.deactivateAllModes();
                this._Globals.coach = true;
                this._Globals.selectedMode = 'coach';
            } else {
                this.router.navigate(['/app/c_a_report', this._Globals.invitationLinkAssignmentId]);
                this._Globals.setMode(this._CryptoJs.encrypt('Client', '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                this._Globals.deactivateAllModes();
                this._Globals.client = true;
                this._Globals.selectedMode = 'client';
            }
            this._Globals.userLoggedIn();
        } else {
            // user login valit but not mach with client id with try to take
            this.toastr.warning('Invalid user credentials for this assessment', 'ELI');
        }
        $('.btn').prop('disabled', false);
        $('body').css('cursor', 'default');
    }

    login(form: NgForm) {
      console.log('ngForm ', form);
      console.log('value form', form.value);
      console.log('user', this.user);
      this._Globals.deactivateAllModes();

      switch (form.value.email) {
          case 'admin':
              this.router.navigate(['/app/admin_dashboard']);
              this._Globals.admin = true;
              this._Globals.selectedMode = 'admin';
              this._Globals.userLoggedIn();
              break;
          case 'coach':
              this.router.navigate(['/app/coach_assessments']);
              this._Globals.coach = true;
              this._Globals.selectedMode = 'coach';
              this._Globals.userLoggedIn();
              break;
          case 'client':
              this.router.navigate(['/app/client_assessments']);
              this._Globals.client = true;
              this._Globals.selectedMode = 'client';
              this._Globals.userLoggedIn();
              break;
          case 'rater':
              this.router.navigate(['/app/rater_assessments']);
              this._Globals.rater = true;
              this._Globals.selectedMode = 'rater';
              this._Globals.userLoggedIn();
              break;
      }
    }

    sendPassword(email: string) {
        this.loading = true;
        const isValid = this.validateEmail(email);
        if (!isValid) {
            this.loading = false;
            return;
        }

        console.log('valid email');
        this.forgotPassword(email);
    }

    validateEmail(email: string): boolean {
        $('body, .btn-primary').css('cursor', 'wait');
        const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        const validEmail = regex.test(email);
        console.log('Valid', validEmail)
        if (validEmail) {
            return true;
        } else {
            this.toastr.warning('Please enter a valid email address', 'ELI');
            $('body, .btn-primary').css('cursor', 'default');
            return false;
        }
    }

    forgotPassword(email: string) {
        this._ClientsService.postForgotPassword(email).subscribe((data: any) => {
            console.log('_PostForgotPassword response', data);

            switch (data.result.Result) {
                case 0:
                    this.toastr.error('We are sorry. An error happened while trying to recover your password.', 'ELI');
                    break;
                case 1:
                    this.toastr.success('An email message with your password has been sent to the provided email address.', 'ELI');
                    break;
                case 4:
                    this.toastr.success(`A message with recover password link has been sent to the provided email address.`, 'ELI');
                    break;
                case -1:
                    this.toastr.warning('No user account found for the provided email address.', 'ELI');
                    break;
                case -2:
                    this.toastr.success('You have not activated your account. We have resent your last assessment assignment invitation email so you can use the link and password provided there in order to activate your account and access your assessment.', 'ELI');
                    break;
                case -3:
                    this.toastr.warning('You have not activated your account and your coach has not yet assigned any assessments to you.', 'ELI');
                    break;
                case -4:
                    this.toastr.error('We were unable to process your request because your account status is not valid or we found multiple accounts matching your user in our records. Please contact student support at support@ipeccoaching.com for further assistance', 'ELI');
                    break;
            }

            $('body, .btn-primary').css('cursor', 'default');
            this.loading = false;
            this.hideForgotPasswordModal();
        })
    }

    showForgotPasswordModal() {
        $('#forgotPassword').modal('show');
    }

    hideForgotPasswordModal() {
        $('#forgotEmail').val('');
        $('#forgotPassword').modal('hide');
    }

    public checkUserSystem(email: string): void
    {
        if (email != "") {
            this.loading = true;
            $('body').css('cursor', 'wait');

            this._ELIAPIService.checkUserAtHubSpot(email).subscribe(
                (response: { Result: number; Message: string; ExtraData: string }) => {

                    console.log('checkUserAtHubSpot response', response);

                    $('body, .btn-primary').css('cursor', 'default');
                    this.loading = false;

                    // Error in the service
                    if (response.Result === 0) {
                        this.toastr.error(
                            'We are sorry. An error happened while trying to validate the user.',
                            'ELI'
                        );
                        return;
                    }

                    // User not found
                    if (response.Result < 0) {
                        this.isOldUser = true;
                        $('#email').attr('disabled', true);
                        return;
                    }

                    // Service executed successfully
                    if (response.Result === 1) {

                        var hubSpotResponse:any = response.Message; // JSON.parse(response.Message);

                        if (hubSpotResponse.total > 0 && hubSpotResponse.results.length > 0) {

                            const userUrl = response.ExtraData;

                            if (userUrl) {
                                window.location.href = userUrl;
                                return;
                            }
                        }
                                                
                        this.isOldUser = true;
                        $('#email').attr('disabled', true);
                    }
                },
                (error) => {
                    console.error(error);

                    $('body, .btn-primary').css('cursor', 'default');
                    this.loading = false;

                    this.toastr.error(
                        'We are sorry. An error happened while trying to validate the user.',
                        'ELI'
                    );
                }
            );
        } else {
            this.toastr.warning('Please enter a valid email address', 'ELI');
        }

    }
}
